(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bmt-story-player"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bmt-story-player')) {
  customElements.define('bmt-story-player', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const trigger = this.querySelector('a');
      const dialog = this.querySelector('dialog');
      const video = this.querySelector('video');
      trigger.addEventListener('click', event => {
        if (!dialog.showModal) return;
        event.preventDefault();
        dialog.showModal();
        video.play().catch(() => {});
      });
      this.querySelector('button').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        if (event.target === dialog) dialog.close();
      });
      dialog.addEventListener('close', () => {
        video.pause();
        video.currentTime = 0;
        trigger.focus();
      });
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
